export default "/images/ic-message.svg?da63a9d60f18d9b080ce8f84d6e5b82f";